﻿import Element from '../utilities/element';
import _ from 'underscore';
import $ from 'jquery'

declare global {
  interface JQuery {
    datetimepicker(options?: any, args?: any): JQuery;
    inputmask(options?: any): JQuery;
    datefield(): JQuery;
  }
}

export class DateField {
  public static get pickerButtonSelector() {
    return '.datefield-button';
  }
  public static get wireup() {
    return '[data-datefield]';
  }
  public get dateFormat() {
    return this.config.dateFormat;
  }

  private dateFormatId: string;
  private hasPicker: boolean;
  private $button: JQuery;
  private config: Configuration;

  public constructor(private $element: JQuery) {
    if (!this.$element || this.$element.length == 0)
      throw Error('Rustig.DateField requires an element');

    try {
      this.$element.data('r-is-constructing', true);
      this.dateFormatId = this.$element.data('datefield');
      this.config = new Configuration(this.dateFormatId);
      this.hasPicker = this.$element.data('picker') == 'on';

      this.validate();
      this.wireupEvents();
      this.applyInputMask();
      this.applyPicker();

      if (!this.hasPicker)
        this.$button.hide();
    }
    finally {
      this.$element.data('r-is-constructing', false);
    }
  }

  private wireupEvents(): void {
    this.$element.change((e) => this.$element.trigger('change.rustig', e))
      .on('dp.change', (e) => this.$element.trigger('change.rustig', e));
  }

  private applyInputMask(): void {
    this.$element.inputmask(this.config.inputMaskOptions);
  }

  private applyPicker(): void {
    this.$element.on('focus.rustig.datefield', (e: JQueryEventObject) => this.onInputFocus(e));
    this.$element.datetimepicker(this.config.datePickerOptions);
    this.$button = this.$element.closest('.datefield').find(DateField.pickerButtonSelector);
    this.$button.on('click.rustig.datefield', (e: JQueryEventObject) => this.onPickerButtonClicked(e));
  }

  private onPickerButtonClicked(e: JQueryEventObject): void {
    e.preventDefault();
    this.$element.data('DateTimePicker').show();
  }

  private onInputFocus(e: JQueryEventObject): void {
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.preventDefault();

    this.$element.trigger('onfocus.rustig');
  }

  private validate(): void {
    if (!this.config.hasSupportedFormat)
      throw Error('The format provided is not supported: ' + this.dateFormatId || '(null)');
  }
}

interface DateFormat {
  id: string;
  inputMaskFormat: string;
  pickerDateFormat: string;
}

class Configuration {
  public hasSupportedFormat: boolean;
  public get datePickerOptions(): any {
    return {
      useCurrent: false,
      viewMode: 'days',
      format: this._dateFormat.pickerDateFormat,
      keyBinds: {
        enter: function () {
          this.hide();
        },
        escape: function () {
          this.hide();
        },
      }
    };
  }
  public get inputMaskOptions(): any {
    return {
      alias: this._dateFormat.inputMaskFormat,
      showMaskOnHover: false,
      clearIncomplete: false,
      yearrange: { minyear: 0, maxyear: 2099 }
    };
  }
  public get dateFormat() {
    return this._dateFormat;
  }

  private _dateFormat: DateFormat;
  private static supportedFormats: Array<DateFormat> = [
    { id: 'date', inputMaskFormat: 'mm/dd/yyyy', pickerDateFormat: 'MM/DD/YYYY' },
    { id: 'datetime', inputMaskFormat: 'mm/dd/yyyy hh:mm xm', pickerDateFormat: 'MM/DD/YYYY HH:mm a' },
    { id: 'time', inputMaskFormat: 'hh:mm t', pickerDateFormat: 'HH:mm a' }
  ];

  public constructor(private dateFormatId) {
    this._dateFormat = this.findDateFormat();
    this.hasSupportedFormat = this._dateFormat != null;
  }

  private findDateFormat(): DateFormat {
    return _.find(Configuration.supportedFormats, (f) => f.id == this.dateFormatId);
  }
}

function Plugin() {
  return this.each(function () {
    var $this = $(this);
    var data = $this.data('rustig.datefield');

    if (!data) {
      data = new DateField($this);
      $this.data('rustig.datefield', data);
    }
  });
}

(<any>$.fn).datefield = Plugin;

